import { first } from 'lodash'
import hooks from '../../../hooks'
import useCourseSurveys from './use-course-surveys'

const useIncompleteUserSurvey = () => {
    const { isActive, snooze } = hooks.useSnooze({ durationMinutes: 120 })
    const { isStudent } = hooks.useCurrentUser()

    const { courseSurveys, isLoadingCourseSurveys } = useCourseSurveys()
    const hasSurveys = isStudent && !isLoadingCourseSurveys && isActive && courseSurveys.length
    const courseSurvey = first(courseSurveys)

    return {
        courseSurvey,
        hasSurveys,
        dismiss: snooze
    }
}

export default useIncompleteUserSurvey
